import * as Sentry from "@sentry/vue";

interface ApiErrorResult {
  readonly ErrorCode?: string;
  readonly ErrorMessage?: string;
  readonly Parameters?: { [key: string]: any };
  readonly SequenceKey?: string;
}

export function sendSentryEvent(err: any) {
  const sentryEnabled = import.meta.env["VITE_SENTRY_ENABLED"] as boolean | undefined;
  if (!sentryEnabled)
    return;

  const errResult = err.result as ApiErrorResult;

  Sentry.captureException(err, scope => {
    if (errResult != null && errResult.SequenceKey != null) {
      scope.setTag("sequenceKey", errResult.SequenceKey);
    }
    return scope;
  });
}
